import React from 'react';
import './HomeBlocks.css';
import { blockTextStyle } from '../../utils/homeLayout';

/**
 * Copy block for the Home layout. Plain text is rendered paragraph by paragraph
 * (never as markup); the HTML mode is only reachable for content the backend
 * already ran through its formatting-only whitelist on save.
 */
function RichTextBlock({ section }) {
  const paragraphs = (section.content || '')
    .split(/\n{2,}/)
    .map((p) => p.trim())
    .filter(Boolean);

  // Nothing written yet: render nothing rather than an empty padded band.
  if (!section.heading && !section.content) return null;

  return (
    <section
      className={`home-text home-text-${section.align || 'left'}`}
      style={blockTextStyle(section)}
    >
      <div className="home-text-inner" style={{ maxWidth: `${section.maxWidth || 720}px` }}>
        {section.heading && <h2 className="home-text-heading">{section.heading}</h2>}

        {section.contentFormat === 'html' ? (
          <div
            className="home-text-body"
            dangerouslySetInnerHTML={{ __html: section.content || '' }}
          />
        ) : (
          <div className="home-text-body">
            {paragraphs.map((paragraph, i) => (
              // Paragraphs have no stable id; order is the identity here.
              <p key={i}>{paragraph}</p>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}

export default RichTextBlock;
